/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { APPLICATION_VIEW_CORPORATE } from '@gh/builder-shared-data';
import { createRoute } from '@gh/builder-shared';
import { MasterZoneDetailsComponent, MasterZoneListComponent } from './components';
import { MasterZoneDetailsBusinessService } from './resources/master-zone-details-business.service';
import { MasterZoneListBusinessService } from './resources/master-zone-list-business.service';

export const routes: Routes = [
  createRoute({
    path: '',
    component: MasterZoneListComponent,
    init: MasterZoneListBusinessService,
    auth: {
      applicationView: APPLICATION_VIEW_CORPORATE,
    },
  }),
  createRoute({
    path: 'new',
    component: MasterZoneDetailsComponent,
    leave: true,
    auth: {
      applicationView: APPLICATION_VIEW_CORPORATE,
    },
    init: MasterZoneDetailsBusinessService,
  }),
  createRoute({
    path: ':masterZoneId',
    component: MasterZoneDetailsComponent,
    leave: true,
    auth: {
      applicationView: APPLICATION_VIEW_CORPORATE,
    },
    init: MasterZoneDetailsBusinessService,
  }),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  declarations: [],
  exports: [RouterModule],
})
export class BuilderMasterZonesRoutingModule {
}
